<template>
    <div class='headerSerc'>
        <div id='style'>
            <div class='headerSerc-item'>
                <span>{{setTingObj.lineColor.title}}</span>
                <color :colorObj="setTingObj.lineColor"></color>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.lineStyle.title}} ({{setTingObj.lineStyle.list[setTingObj.lineStyle.type].val}})</span>
                <radio :list="setTingObj.lineStyle.list" :type="setTingObj.lineStyle.type" @change="updateLineStyle"></radio>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.heightConfig.title}}</span>
                <sliderAndInput :lrConfig="setTingObj.heightConfig"></sliderAndInput>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.lrEdge.title}}</span>
                <sliderAndInput :lrConfig="setTingObj.lrEdge"></sliderAndInput>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.mbConfig.title}}</span>
                <sliderAndInput :lrConfig="setTingObj.mbConfig"></sliderAndInput>
            </div>
        </div>
    </div>
</template>

<script>
import tab from '@/components/decoration/common/tab.vue'
import color from '@/components/decoration/common/color.vue';
import radio from '@/components/decoration/common/radio.vue';
import sliderAndInput from '@/components/decoration/common/sliderAndInput.vue';
export default {
    components:{
        sliderAndInput,
        radio,
        color,
        tab
    },
    props: {
        setTingObj: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {

        };
    },
    methods: {
        updateLineStyle(type){
            this.setTingObj.lineStyle.type = type
        }
    }
};
</script>

<style lang='scss' scoped>

</style>